import React from 'react';

interface DescriptionProps {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'base' | 'lg';
  id?: string;
  name?: string;
}

export default function Description({ 
  children, 
  className = '',
  size = 'base',
  id,
  name
}: DescriptionProps) {
  const baseStyles = 'text-gray-600';
  const sizes = {
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg'
  };

  return (
    <div 
      className={`${baseStyles} ${sizes[size]} ${className}`}
      id={id}
      data-name={name}
    >
      {children}
    </div>
  );
}